import { AuthConfig, OAuthModuleConfig } from 'angular-oauth2-oidc';

import { environment } from '@env/environment';

export const oauthModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: ['/api'],
    sendAccessToken: true,
  },
};

export const authConfig: AuthConfig = {
  issuer: window.location.origin + environment.keycloak.issuer,
  clientId: environment.keycloak.clientId,
  redirectUri: window.location.origin,
  postLogoutRedirectUri: window.location.origin,
  responseType: 'code',
  scope: 'openid profile email',
  showDebugInformation: true,
};
